import { connect } from "react-redux";
import * as Redux from "redux";
import { withRouter } from "react-router-dom";
import {
  resetAggregatedMetrics,
  removePublications,
  getAggregatedMetrics,
  setPublicationSelection,
  setMerchantSelection,
  getPublications,
  setEndDate,
  setStartDate,
  setMetricsContainerTab,
  getAnalyticsMerchants,
  setGlobalFiltersSelection,
  setMetricSelection
} from "../../actions";
import {
  setMetricContentGroupBy,
  setMetricContentCompareBy,
  setMetricContentView,
  clearMetricData
} from "../../../AnalyticsMetric/actions";
import {
  getViewContext,
  currentMerchantName
} from "../../../Analytics/selectors";
import { getUserContext } from "../../../User/selectors";
import AnalyticsMetricContainer from "./component";
import {
  AnalyticsGlobalFilters,
  AggregatedMetrics,
  Publication
} from "../../constants";
import { Merchant } from "../../../Merchant";
import { merchants } from "../../selectors";

export interface AnalyticsMetricContainerProps {
  merchants: Merchant[];
  currentMerchantName: string;
  merchant_id: number;
  publications: Publication[];
  publication_ids: number[];
  analytics_metrics: AggregatedMetrics;
  start_date: string;
  end_date: string;
  publications_loading: boolean;
  analytics_metrics_loading: boolean;
  permissions: any;
  features: any;
  gaUserContext: any;
  gaViewContext: any;
  globalFilters: AnalyticsGlobalFilters;
}

export interface AnalyticsContainerActions {
  getAggregatedMetrics: (
    flyer_run_ids: number[],
    merchant_id: number,
    start_date: string,
    end_date: string,
    metrics: string[]
  ) => void;
  getPublications: (
    merchant_id: number,
    start_date: string,
    end_date: string
  ) => void;
  getAnalyticsMerchants: (q?: string) => void;
  setStartDate: (start_date: string) => void;
  setEndDate: (end_date: string) => void;
  setMetricsContainerTab: (tabname: string) => void;
  setMerchantSelection: (merchant_id: number) => void;
  setPublicationSelection: (publicationIds: number[]) => void;
  setMetricContentGroupBy: (selection: string) => void;
  setMetricContentCompareBy: (selection: string) => void;
  setMetricContentView: (selection: string) => void;
  resetAggregatedMetrics: () => void;
  removePublications: () => void;
  clearMetricData: () => void;
  setGlobalFiltersSelection: (filters: AnalyticsGlobalFilters) => void;
  setMetricSelection: (metric: string, merchant_id: number) => void;
}

const mapStateToProps = (
  state: any,
  props: any
): AnalyticsMetricContainerProps => {
  return {
    merchants: state.merchant,
    merchant_id: state.analytics.merchant_id,
    currentMerchantName: currentMerchantName(state),
    publications: state.analytics.publications, //todo: create type for publication object
    publication_ids: state.analytics.publication_ids
      ? state.analytics.publication_ids
      : [],
    analytics_metrics: state.analytics.analytics_metrics,
    start_date: state.analytics.start_date,
    end_date: state.analytics.end_date,
    publications_loading: state.analytics.publications_loading,
    analytics_metrics_loading: state.analytics.analytics_metrics_loading,
    permissions: state.user.permissions,
    features: state.user.features,
    gaUserContext: getUserContext(state),
    gaViewContext: getViewContext(state),
    globalFilters: state.analytics.globalFilters
  };
};

const mapDispatchToProps = (
  dispatch: Redux.Dispatch<any>
): AnalyticsContainerActions => {
  return {
    ...Redux.bindActionCreators(
      {
        getAggregatedMetrics,
        resetAggregatedMetrics,
        getPublications,
        removePublications,
        getAnalyticsMerchants,
        setPublicationSelection,
        setMerchantSelection,
        setEndDate,
        setStartDate,
        setMetricsContainerTab,
        setMetricContentGroupBy,
        setMetricContentCompareBy,
        setMetricContentView,
        clearMetricData,
        setGlobalFiltersSelection,
        setMetricSelection
      },
      dispatch
    )
  };
};

// Wrapping connect and withRouter prevents the components props.location object from not updating.
// https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/guides/blocked-updates.md
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AnalyticsMetricContainer)
);



// WEBPACK FOOTER //
// ./client/modules/Analytics/components/AnalyticsContainer/container.tsx